export * from './VoiceRecordingSelect.container'



// WEBPACK FOOTER //
// src/features/Voices/VoiceRecordingSelect/index.ts